import { render } from "./ChecklistItem.vue?vue&type=template&id=5fe5233e"
import script from "./ChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__